import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-kpi-card',
    templateUrl: './kpi-card.component.html',
    styleUrls: ['./kpi-card.component.scss']
})
export class KpiCardComponent {
    @Input() label: string;
    @Input() value: string | number;
    @Input() hint: string;
    @Input() variant: 'default' | 'success' | 'warning' | 'danger' = 'default';
}
